// SavedViewsBar — chip-strip met opgeslagen views + save/delete acties.

import { useState } from "react";

interface Props {
  views: Array<{ name: string }>;
  onApply: (name: string) => void;
  onSave: (name: string) => void;
  onDelete: (name: string) => void;
}

export function SavedViewsBar({ views, onApply, onSave, onDelete }: Props) {
  const [adding, setAdding] = useState(false);
  const [name, setName] = useState("");

  const commit = () => {
    const n = name.trim();
    if (n) { onSave(n); setName(""); setAdding(false); }
  };

  return (
    <div style={{
      display: "flex", gap: 6, alignItems: "center", flexWrap: "wrap",
      padding: "4px 0", fontSize: "var(--fs-sm)",
    }}>
      <span style={{ color: "var(--color-text-muted)", marginRight: 4 }}>Views:</span>
      {views.length === 0 && !adding && (
        <span style={{ color: "var(--color-text-muted)", fontStyle: "italic" }}>nog geen</span>
      )}
      {views.map((v) => (
        <span key={v.name} className="badge" style={{
          padding: "2px 6px", fontSize: 12, display: "inline-flex", alignItems: "center", gap: 4,
          background: "var(--color-bg-elevated, #334155)", cursor: "pointer",
        }}
        onClick={() => onApply(v.name)}
        title="Klik om toe te passen">
          {v.name}
          <button
            onClick={(e) => { e.stopPropagation(); if (confirm(`View "${v.name}" verwijderen?`)) onDelete(v.name); }}
            style={{
              background: "transparent", border: "none", color: "inherit",
              opacity: 0.6, cursor: "pointer", padding: 0, fontSize: 11, lineHeight: 1,
            }}
            title="Verwijder view"
          >×</button>
        </span>
      ))}
      {adding ? (
        <>
          <input
            type="text" value={name} autoFocus
            onChange={(e) => setName(e.target.value)}
            onKeyDown={(e) => { if (e.key === "Enter") commit(); if (e.key === "Escape") setAdding(false); }}
            placeholder="Naam…"
            style={{ height: 24, padding: "0 6px", fontSize: 12, width: 120 }}
          />
          <button className="btn btn-ghost" style={{ padding: "1px 8px", fontSize: 12 }} onClick={commit}>✓</button>
          <button className="btn btn-ghost" style={{ padding: "1px 8px", fontSize: 12 }} onClick={() => setAdding(false)}>×</button>
        </>
      ) : (
        <button
          className="btn btn-ghost"
          style={{ padding: "2px 8px", fontSize: 12 }}
          onClick={() => setAdding(true)}
        >+ Opslaan</button>
      )}
    </div>
  );
}
